import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { Versions, Viewdata, GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { UserhelpService } from './userhelp.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-userhelp',
  templateUrl: './userhelp.component.html',
  styleUrls: ['./userhelp.component.css']
})
export class UserhelpComponent {

  showcount: number = 0;
  hidecount: number = 0;
  working: boolean = true;
  ref: DynamicDialogRef | undefined;
  commonScrollHeight = '';
  numberofrowsingrid: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  buttonOption = [];
  items: MenuItem[] | undefined;
  selectedItem: MenuItem | null = null;
  tableData: any[] = [];
  searchText: string;
  helplist: any;
  listarray: Array<Versions> = [];
  sortOrder = 1;
  sortProperty: string = 'topic';
  dataview: Viewdata = new Viewdata();
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  numberofrowsintable: number = 10;
  visible: boolean = false;
  position = 'top';
  cols = [];
  _selectedColumns = [];
  message: GlobalMessage = new GlobalMessage()
  public isView: boolean = false;

  constructor(
    private UserhelpService: UserhelpService,
    public router: Router,
    public dialogService: DialogService,
    private spinner: NgxSpinnerService,
    public helpservice: PagehelpmodalService,
    private utilityservice: Utilityservice) {
  }
  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.gettabledata();
    this.dynamiccols();
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'productinitial', header: 'Product Name', type: 'text', sort: true, filter: true, isChecked: true, class: 'headerid' },
      { field: "topic", header: "Help Topic", type: 'text', sort: true, filter: true, isChecked: true, class: 'otherheader' },
      { field: "helptext", header: "Help Text", type: 'text', sort: true, filter: true, isChecked: true, class: 'otherheader' },
    ]
    this._selectedColumns = this.cols;
  }

  gettabledata() {
    this.UserhelpService.getuserhelptabledata().subscribe((data) => {
      this.helplist = data;
      this.listarray = this.helplist;
      this.options = this.UserhelpService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
      this.listarray.map(e => {
        e['isSelect'] = false
      })
      this.totalRecords = this.listarray.length;
      this.tablecount = this.helplist.count;
    });
    // this.UserhelpService.getuserhelptabledata().subscribe((data: any) => {
    //   this.helplist = data;
    // });
  }

  goToPage(url, productinitial) {
    const product = productinitial?.toLowerCase();

    if (product === 'compliance') {
      window.location.href = `/compliance/#/${url}`;
    } else if (product === 'registration') {
      window.location.href = `/registration/#/${url}`;
    } else if (product === 'ifc') {
      window.location.href = `/ifc/#/${url}`;
    }else if (product === 'task') {
      window.location.href = `/task/#/${url}`;
    }else if (product === 'contract') {
      window.location.href = `/contract/#/${url}`;
    }else if (product === 'assessment') {
      window.location.href = `/assessment/#/${url}`;
    }else if (product === 'documents') {
      window.location.href = `/documents/#/${url}`;
    }else if (product === 'insurance') {
      window.location.href = `/insurance/#/${url}`;
    }else if (product === 'secretarial') {
      window.location.href = `/secretarial/#/${url}`;
    }else if (product === 'audit') {
      window.location.href = `/audit/#/${url}`;
    }else if (product === 'litigation') {
      window.location.href = `/litigation/#/${url}`;
    }else if (product === 'helpdesk') {
      window.location.href = `/helpdesk/#/${url}`;
    }else if (product === 'crm') {
      window.location.href = `/crm/#/${url}`;
    }else {
      this.router.navigate([url]);
    }
  }
  handlePageChange(event: any) {
    this.numberofrowsintable = event.rows
  }

  filedata: any = []
  setEvent(event) { this.filedata = event }
  handleDialogClose() { this.filedata = []; }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;
      // Convert date strings to Date objects if they are valid date formats
      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        // Check for specific sorting logic for processstepname
        if (event.field === 'title') {
          result = value1.toLowerCase().localeCompare(value2.toLowerCase());
        } else if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        // Fallback to default number comparison
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;  // Multiply by order (-1 for descending, 1 for ascending)
    });
  }

  searchTerm: string = '';
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
